import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ellipsisSlice'
})
export class EllipsisSlicePipe implements PipeTransform {

  transform(value: string, threshold: number): string {
    if (value.length <= threshold) {
      return value;
    }
    return `${value.slice(0, threshold)}...`
  }

}
